import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const Microsoft = ({ size, color, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={48} size={size}>
    <g fill={color}>
      <path fill="#F25022" d="M6,6h17v17H6V6z" />
      <path fill="#7FBA00" d="M25,6h17v17H25V6z" />
      <path fill="#00A4EF" d="M6,25h17v17H6V25z" />
      <path fill="#FFB900" d="M25,25h17v17H25V25z" />
    </g>
  </IconBase>
);
